"use client";

import { useAPYContext } from "@/features/apy";

export default function DisclaimerText() {
  const { standardApyRate } = useAPYContext();

  return (
    <>
      <small>
        Eden Financial Technologies Incorporated (&quot;Cove&quot;) is not a bank. Cove
        is a financial technology company and an SEC-registered Investment
        Adviser. Registration does not imply a certain level of skill or
        training. Banking services are provided by Alpaca Securities LLC.
      </small>
      <br />
      <br />
      <small className="font-bold">* Annual Percentage Yield (APY)</small>
      <br />
      <small>
        The APY displayed is the boosted rate, which new Clients receive for an
        initial period and which is also available to Premium subscribers and
        through the referral program. After the boost ends, Clients earn the
        standard rate
        {standardApyRate ? `, currently ${standardApyRate}% APY` : ""}. Rates
        are variable and subject to change. The APY is generated from
        uninvested cash held in a brokerage account through a sweep program,
        which is not a traditional savings account. More information can be
        found in the Alpaca Customer Agreement.
      </small>
      <br />
      <br />
      <small className="font-bold">* & ** Cash Sweep Program</small>
      <br />
      <small>
        Uninvested cash is swept to one or more FDIC-insured program banks
        through our partner broker-dealer, Alpaca Securities LLC. Each program
        bank provides FDIC insurance up to $250,000 per depositor, allowing up
        to $1,000,000 in combined FDIC coverage if your cash is spread across
        four partner banks. FDIC insurance does not cover any securities or
        other investments. More information can be found in the Alpaca
        Customer Agreement.
      </small>
      <br />
      <br />
      <small className="font-bold">** Investments & SIPC Insurance</small>
      <br />
      <small>
        Brokerage services are provided by Alpaca, a registered broker-dealer
        and member FINRA/SIPC. Investments held in your Cove brokerage account
        are SIPC protected up to $500,000 (including up to $250,000 for cash).
        SIPC does not protect against losses due to market fluctuations. More
        information can be found in the Alpaca Customer Agreement.
      </small>
      <br />
      <br />
      <small>
        Investment advice is provided by Eden Financial Technologies
        Incorporated DBA Cove. Eden Financial Technologies Incorporated DBA
        Cove is an SEC-registered investment adviser. Investment advice is
        provided by Cove and investments in your Cove account are not FDIC
        INSURED, NOT BANK GUARANTEED, and MAY LOSE VALUE. Alpaca Securities
        LLC serves as the qualified custodian for Eden Financial Technologies
        Incorporated DBA Cove. Alpaca Securities LLC is a member of FINRA and
        SIPC.
      </small>
      <br />
      <br />
      <small>
        Nothing on this website should be considered an offer, solicitation of
        an offer, tax, legal, or investment advice to buy or sell securities.
        Any performance information is illustrative in nature and may not
        reflect actual performance. Account holdings are for illustrative
        purposes only and are not investment recommendations. All investments
        are subject to risk and may lose value.
      </small>
      <br />
      <br />
      <small>
        All logos used herein are the respective intellectual property of
        their copyright holders.
      </small>
    </>
  );
}